import { Theme, ThemeOptions } from '@mui/material'

const linkedHeadingStyle = (theme: Theme) => ({
    '&:is(a)': {
        '&:hover': {
            color: theme.palette.primary.dark,
            textDecoration: 'none',
        },
    },
})

export default (theme: Theme): ThemeOptions['components'] => ({
    MuiTypography: {
        defaultProps: {
            variantMapping: {
                h3: 'h2',
                caption: 'div',
                overline: 'div',
            },
        },
        styleOverrides: {
            gutterBottom: {
                marginBottom: 8,
            },
            h2: {
                ...linkedHeadingStyle(theme),
            },
            h3: {
                ...linkedHeadingStyle(theme),
            },
            h4: {
                ...linkedHeadingStyle(theme),
            },
        },
    },
})
